import styled from 'react-emotion';

const Container = styled('main')`
  min-width: 100vw;
  min-height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  display: grid;
  grid-template-rows: 15vh 70vh 15vh;
  transition: opacity 500ms ease-in-out;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container.ts